export const API = {
    upload: '/api/qualify/upload',
    qualifyInfo: '/api/qualify/info',
    addPersonQualify: '/api/qualify/person',
    addCompanyQualify: '/api/qualify/company',
    sync: '/api/qualify/sync',
    watch: '/api/qualify/watch',
    birthday: '/api/qualify/birthday',
    licenseApply: '/api/qualify/license/apply',
    licenseUpdate: '/api/qualify/license/update',
    licenseDelete: '/api/qualify/license/delete',
    licenseInfo: '/api/qualify/license/info',
    licenseList: '/api/qualify/license/list',
    passInfo: '/api/qualify/passinfo',
    syncPass: '/api/qualify/syncpass',
    faceIntention: '/api/qualify/faceIntention',
    financeSendAuthCode: '/api/qualify/v3/corporation/payment/send/code',
    applyExclusiveAccount: '/api/finance/account/applyExclusiveAccount',
    getAccountTelephone: '/api/finance/account/telephone',
    queryCompPayment: '/api/qualify/v3/corporation/payment/query',
    createPaymentProcess: '/api/qualify/v3/corporation/payment/create',
    submitPayment: '/api/qualify/v3/corporation/payment/submit',
    availableAuth: '/api/qualify/auth/way',
    // 个人银行卡认证
    sendPerBankAuthCode: '/api/qualify/v3/person/bank/card/code/send',
    submitPerBank: '/api/qualify/v3/person/bank/card/submit',
    queryPerBank: '/api/qualify/v3/person/bank/card/query',
    // 法人刷脸认证
    legalVerifyToken: '/api/qualify/v3/corporation/livingBody/token',
    // 对公打款
    queryCompTransfer: '/api/qualify/v3/corporation/transfer/query',
    submitCompTransfer: '/api/qualify/v3/corporation/transfer/submit',
    verifyCompTransfer: '/api/qualify/v3/corporation/transfer/amount/verify',
    compBankList: '/api/qualify/v3/corporation/transfer/bank/list',
    applyCompTransfer: '/api/qualify/v3/corporation/transfer/remit',
    remitFaceQuery: '/api/qualify/v3/corporation/transfer/face/query',
    remitFaceToken: '/api/qualify/v3/corporation/transfer/token',
    // 个人刷脸
    personFaceSubmit: '/api/qualify/v3/person/livingBody/submit',
    queryPersonFace: '/api/qualify/v3/person/livingBody/result/PC',
    // 刷脸token
    legalToken: '/api/qualify/v3/corporation/livingBody/legalPerson/token',
    personToken: '/api/qualify/v3/person/livingBody/token',
    authorizedToken: '/api/qualify/v3/corporation/livingBody/authorizedPerson/token',
    legalLivingSubmit: '/api/qualify/v3/corporation/livingBody/legalPerson/submit',
    legalLivingResult: '/api/qualify/v3/corporation/livingBody/legalPerson/result/PC',
    legalAuthorizedLivingResult: '/api/qualify/v3/corporation/livingBody/authorizedPerson/result/PC',
    // 被授权人刷脸提交
    legalAuthorizedLivingSubmit: '/api/qualify/v3/corporation/livingBody/authorizedPerson/submit',
    // 个人证件认证
    queryPersonCertificate: '/api/qualify/v3/person/certificate/query',
    submitPersonCertificate: '/api/qualify/v3/person/certificate/submit',
    // 营业执照OCR
    businessOcr: '/api/qualify/v3/ocr/business/license',
    // 转换短链接
    getShortUrl: '/api/qualify/short/urls/builder',
    // 个人变更
    changeInfo: '/api/qualify/v3/change/info',
    changeLog: '/api/qualify/v3/change/query/records',
    drawbackChange: '/api/qualify/v3/change/drawback',
    qualifyWithdraw: '/api/qualify/withdraw',
    enableAuthorizedPerson: '/api/qualify/v3/corporation/livingBody/authorizedPerson/allow/auth',
    faceLog: '/api/qualify/livingBody/userToken',
    // 获取变更前企业信息及爱企查企业信息
    getCompLatestInfo: '/api/qualify/v3/businessLicense/match',
    // 企业工商变更记录
    getCompUpdateLog: '/api/qualify/v3/corporation/change/info',
    // 查询企业工商变更流程状态
    getCompChangeInfo: '/api/qualify/v3/corporation/change/query',
    // 提交高级实名企业工商变更
    submitCompChange: '/api/qualify/v3/corporation/change/submit',
    // 二要素校验
    twoFactorCheck: '/api/qualify/v3/businessLicense/check',
    // console常量接口
    constantV3: '/api/system/constants/v3',
    // 非工商变更
    compChangeCheck: '/api/qualify/v3/corporation/real/change/check',
    compChangeOriginQuery: '/api/qualify/v3/corporation/real/change/origin/query',
    compChangeOriginSubmit: '/api/qualify/v3/corporation/real/change/baseinfo/submit',
    compChangeOriginPersonFace: '/api/qualify/v3/corporation/real/change/origin/person/submit',
    compFileOriginSubmit: '/api/qualify/v3/corporation/real/change/form/submit',
    compChangeFaceToken: '/api/qualify/v3/corporation/real/change/auth/token',
    getCompChangeForm: '/api/qualify/v3/corporation/real/change/form/query',
    compChangeFaceQuery: '/api/qualify/v3/corporation/real/change/face/query',
    authorizedPersonFaceQuery: '/api/qualify/v3/corporation/livingBody/authorizedPerson/result/H5',
    legalFaceQuery: '/api/qualify/v3/corporation/livingBody/legalPerson/result/H5',
    personFaceQuery: '/api/qualify/v3/person/livingBody/result/H5',
    compChangeAgreement: '/api/qualify/v3/corporation/real/change/agreement',
    // 查询企业名称是否在管制清单内
    checkCompInRestrict: '/api/qualify/risk/check',
    // 生成授权书模板
    generateAuthorization: '/api/qualify/v3/corporation/livingBody/authorizedPerson/authorization/generate',
};
